const API_KEY = 'AIzaSyCsfSOjsGJv41pT4WlnQA2CB3V2DrNgQIU';

module.exports = API_KEY;



// WEBPACK FOOTER //
// ./src/key.js